import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
createApp(App).use(router).mount("#app");

import Vue from "vue";
import Buefy from "buefy";
import "buefy/dist/buefy.css";

Vue.use(Buefy);

//Firebase...
// Import the functions you need from the SDKs you need
//import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAUYHWFKf0ngduwmnwcglo8FNhyUipP9iQ",
  authDomain: "reinventappstore.firebaseapp.com",
  projectId: "reinventappstore",
  storageBucket: "reinventappstore.appspot.com",
  messagingSenderId: "230157925397",
  appId: "1:230157925397:web:9c390a3595a4d41b60621c",
  measurementId: "G-76XPLP0B9H",
};

// Initialize Firebase
//const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.config.productionTip = false;

// alias
Vue.prototype.$analytics = firebase.analytics();
